import { render, staticRenderFns } from "./NotificationCardForPathActivity.vue?vue&type=template&id=c5d4c998&scoped=true&"
import script from "./NotificationCardForPathActivity.vue?vue&type=script&lang=js&"
export * from "./NotificationCardForPathActivity.vue?vue&type=script&lang=js&"
import style0 from "./NotificationCardForPathActivity.vue?vue&type=style&index=0&id=c5d4c998&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5d4c998",
  null
  
)

export default component.exports